import Vue from 'vue';

// Domain
import CustomerCellphoneStateManager from '../../domain/state/customer-cellphone-state-manager';
import CustomerCellphoneState from '../../domain/state/customer-cellphone-state';
import Injectable from '@/modules/shared/domain/di/injectable';
import Observer from '@/modules/shared/domain/observer/observer';

@Injectable()
export default class VueStateManager implements CustomerCellphoneStateManager {
  // eslint-disable-next-line max-len
  private _state: CustomerCellphoneState = Vue.observable<CustomerCellphoneState>(new CustomerCellphoneState());

  private readonly observers: Observer[] = [];

  get state(): CustomerCellphoneState {
    return this._state;
  }

  set state(value: CustomerCellphoneState) {
    this._state = value;
    this.notifyAll();
  }

  patch(state: Partial<CustomerCellphoneState>) {
    type Keys = keyof CustomerCellphoneState;
    Object.entries(state).forEach(([key, value]) => {
      const accessor = key as Keys;

      if (value !== undefined) {
        // eslint-disable-next-line
        // @ts-ignore @typescript-eslint/ban-ts-ignore
        this.state[accessor] = value;
      }
    });
  }

  notifyAll() {
    this.observers.forEach((observer) => observer.notify());
  }

  register(observer: Observer) {
    this.observers.push(observer);
  }
}
